import React from 'react';
import { awsSecurityConfiguration } from '@lyearn-team/reporting-library';
import cookie from '../../helper/cookie';
import validateJWT from '../../helper/validateJWT';
import refetchTokens from '../../helper/refetchTokens';

async function fetchValidCookies(cookieName) {
  const lyearnToken = cookie.get('lyearn_token');
  const isValid = validateJWT(lyearnToken);
  if (!isValid) {
    await refetchTokens();
  }

  return cookie.get(cookieName);
}

export default class ReportingLibraryInit extends React.Component {
  async componentDidMount() {
    awsSecurityConfiguration.initialiseCredentialGetters({
      getAccessKey: () => fetchValidCookies('cognito_access_key'),
      getSecretKey: () => fetchValidCookies('cognito_secret_key'),
      getSessionToken: () => fetchValidCookies('cognito_session_token')
    });
  }

  render() {
    return null;
  }
}
